// extracted by mini-css-extract-plugin
export var card = "_v2-0";
export var details = "_v2-1";